/** Responsive grid: one field per row ≤490px, paired stacks 491–639px, tabular from `sm`. */
export const ORDER_LIST_ROW_LAYOUT =
    'grid min-w-0 grid-cols-1 grid-rows-[repeat(5,auto)] gap-y-2 min-[491px]:grid-cols-[minmax(0,1fr)_auto_auto] min-[491px]:grid-rows-[auto_auto] min-[491px]:gap-x-6 min-[491px]:gap-y-1 sm:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1.25fr)_1.5rem] sm:grid-rows-1 sm:items-center sm:gap-x-2';

/** Date cell — row 1 when narrow, top-left when paired, first column on desktop. */
export const ORDER_LIST_DATE_CELL =
    'min-w-0 col-start-1 row-start-1 break-words text-left min-[491px]:col-start-1 min-[491px]:row-start-1 sm:col-start-1 sm:row-start-1';

/** Item count cell — row 2 when narrow, below date when paired, second column on desktop. */
export const ORDER_LIST_ITEMS_CELL =
    'min-w-0 col-start-1 row-start-2 break-words text-left min-[491px]:col-start-1 min-[491px]:row-start-2 sm:col-start-2 sm:row-start-1';

/** Amount cell — row 3 when narrow, top-right when paired, third column on desktop. */
export const ORDER_LIST_AMOUNT_CELL =
    'min-w-0 col-start-1 row-start-3 break-words text-left min-[491px]:col-start-2 min-[491px]:row-start-1 sm:col-start-3 sm:row-start-1 sm:text-right';

/** Status cell — row 4 when narrow, below amount when paired, fourth column on desktop. */
export const ORDER_LIST_STATUS_CELL =
    'min-w-0 col-start-1 row-start-4 min-[491px]:col-start-2 min-[491px]:row-start-2 sm:col-start-4 sm:row-start-1 sm:flex sm:justify-end';

/** Chevron — row 5 when narrow, spans paired rows, last column on desktop. */
export const ORDER_LIST_ROW_ACTION =
    'col-start-1 row-start-5 justify-self-end min-[491px]:col-start-3 min-[491px]:row-start-1 min-[491px]:row-span-2 min-[491px]:justify-self-auto min-[491px]:self-center sm:col-start-5 sm:row-span-1 size-6 shrink-0';

/** Shared card chrome for order list rows. */
export const ORDER_LIST_CARD_CLASS = 'rounded-sm border-0 bg-sand-95 shadow-none p-4';

/** Mobile card (< `sm`): two flexible columns so long status badges stay in the right half. */
export const ORDER_LIST_MOBILE_LAYOUT =
    'grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)_auto] gap-y-2 gap-x-2 p-4 rounded-sm bg-sand-95 sm:hidden';

export const ORDER_LIST_MOBILE_DATE_CELL = 'body-copy-l-bold min-w-0 col-start-1 row-start-1';

export const ORDER_LIST_MOBILE_AMOUNT_CELL =
    'body-copy-l min-w-0 justify-self-end whitespace-nowrap col-start-2 row-start-1';

export const ORDER_LIST_MOBILE_ITEMS_CELL = 'body-copy-l min-w-0 col-start-1 row-start-2';

export const ORDER_LIST_MOBILE_STATUS_CELL = 'col-start-2 row-start-2 flex justify-self-end';

export const ORDER_LIST_MOBILE_ROW_ACTION = 'col-start-3 row-start-1 row-span-2 self-center size-6 justify-self-end';
